import axios from "axios"
import { BASEURL, getToken } from "./utils"
const api = axios.create({
    baseURL: BASEURL,
    imeout: 30 * 1000 // API request timeout set to 30s
})

api.interceptors.request.use(async config => {
    const token = getToken() //
    config.headers.Authorization = token != null ? `Bearer ${token}` : `Bearer `
    config.headers.Idcliente = 2
    return config
})

export default api
